import { ChangeDetectorRef, Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { TranslatePipe } from '@ngx-translate/core';
import { UnsubscribeOnDestroyAdapter } from '@shared/unsubscribe-on-destroy-adapter';
import { NgScrollbar } from 'ngx-scrollbar';
import { FeatherIconsComponent } from '../feather-icons/feather-icons.component';
import { NotificationControllerService, NotificationDto, NotificationResponseDto } from '@core/api';
import { MatButtonModule } from '@angular/material/button';
import { HttpErrorResponse } from '@angular/common/http';
import { RouterLink } from '@angular/router';
import { NgTemplateOutlet } from '@angular/common';
import { TimeAgoPipe } from '@shared/pipes/time-ago.pipe';

@Component({
    selector: 'app-header-notification',
    templateUrl: './header-notification.component.html',
    styleUrls: ['./header-notification.component.scss'],
    imports: [
        TranslatePipe,
        MatButtonModule,
        FeatherIconsComponent,
        MatMenuModule,
        NgScrollbar,
        RouterLink,
        NgTemplateOutlet,
        TimeAgoPipe,
    ],
})
export class HeaderNotificationComponent extends UnsubscribeOnDestroyAdapter implements OnInit, OnDestroy {
    private readonly _notificationControllerService = inject(NotificationControllerService);
    private readonly _cd = inject(ChangeDetectorRef);

    private _intervalId = 0;
    notifications: NotificationDto[] = [];
    isReaded = signal<boolean>(false);

    NotificationType = NotificationDto.NotificationTypeEnum;

    constructor() {
        super();
    }

    ngOnInit(){
        this.createSubscriptions();
        this.setRefreshNotification();
    }

    override ngOnDestroy(){
        super.ngOnDestroy()
        clearInterval(this._intervalId);
    }

    private createSubscriptions() {}

    private setRefreshNotification(){
        this.refreshNotification(); // first

        this._intervalId = setInterval(() => {
            this.refreshNotification();
        }, 10000);
    }

    private refreshNotification(){
        this.subs.add(
            this._notificationControllerService.getNotifications().subscribe({
                next: (response: NotificationResponseDto) => {
                    if(response.notificationDtos.length > 0){
                        this.notifications = [...this.notifications, ...response.notificationDtos.filter((notification) => notification.state === NotificationDto.StateEnum.New)];
                        if(this.notifications.length > 0){
                            this.isReaded.set(false);
                        }
                    }
                },
                error: (error: HttpErrorResponse) => {
                    // error
                    console.error(error);
                },
            })
        );
    }

    onMenuOpened(){
        // console.dir('onMenuOpened');
        // this.isReaded.set(true);
    }

    onMenuClosed(){
        // console.dir('onMenuClosed');
        // this.isReaded.set(true);
    }

    onRemoveNotification(index: number){
        this.notifications.splice(index, 1);
        this._cd.detectChanges();
    }

    onMarkAllasRead(){
        this.notifications = [];
        this.isReaded.set(true);
        this._cd.detectChanges();
    }
}
